<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-3">
              <b-form-checkbox
                v-model="draft"
                value="0"
                unchecked-value="1"
                class="custom-control-dark"
                switch
                inline
                @input="refresh()"
              >
                المقاريء في انتظار التفعيل
              </b-form-checkbox>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <input
                  type="text"
                  autofocus
                  class="form-control"
                  v-model="search"
                  @input="(val) => searchChange(val)"
                  :placeholder="$t(`site.search`)"
                />
              </div>
            </div>
            <div class="col-3">
              <div class="float-md-right pt-1">
                <span class="text-muted text-small mr-1 mb-2">
                  {{ from }}:{{ to }}
                </span>

                <b-dropdown
                  id="ddown2"
                  right
                  :text="`${perPage}`"
                  variant="outline-warning"
                  size="xs"
                >
                  <b-dropdown-item
                    v-for="(size, index) in [5, 10, 20, 50, 100]"
                    :key="index"
                    @click="changePageSize(size)"
                    >{{ size }}</b-dropdown-item
                  >
                </b-dropdown>
                <span class="text-muted mr-1 mb-2"> of {{ total }}</span>
              </div>
            </div>
          </div>
          <div class="row" v-if="$role=='super_admin'">
            <div class="col-12">
              <b-dropdown v-if="$role == 'super_admin' || $role == 'QuranAdmin'"
                :text="$t('quran_programs.teachers')"
                variant="flat-primary">
                  <!--Teachers dropdown-->
                <b-dropdown-item v-for="teacher in teachers" @click="filterTeachers(teacher.id)">
                  {{ teacher.full_name  }}
                </b-dropdown-item>
              </b-dropdown>
            
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 overflow-auto">
              <b-card>
                <b-table
                  :stacked="$mobile == 1"
                  responsive
                  ref="table"
                  class="vuetable"
                  sort-by="id"
                  sort-desc.sync="false"
                  :current-page="currentPage"
                  :fields="bootstrapTable.fields"
                  :items="dataProvider"
                  style="min-height: 250px"
                >
                  <template #cell(checkbox)="data">
                    <label
                      class="kt-checkbox kt-checkbox--single kt-checkbox--solid"
                    >
                      <input
                        type="checkbox"
                        v-model="recordIds"
                        :value="data.item.id"
                        @change="selectItem(data)"
                      />
                      <span></span>
                    </label>
                  </template>

                  <template #cell(room_type)="data">
                    <b-badge
                      variant="light-info"
                      v-if="data.item.room_type == 0"
                    >
                      {{ $t("quran_programs.group") }}
                    </b-badge>
                    <b-badge variant="light-dark" v-else>
                      {{ $t("quran_programs.single") }}
                    </b-badge>
                  </template>

                  <template #cell(quran_schedule_date)="data">
                    <router-link
                      :to="
                        '/page/profile/' +
                          data.item.quran_schedule_date[0].students[0].id
                      "
                    >
                      <b-badge
                        variant="light-info"
                        v-if="
                          data.item.quran_schedule_date.length > 0 &&
                            data.item.quran_schedule_date[0].students.length > 0
                        "
                      >
                        {{
                          data.item.quran_schedule_date[0].students[0].full_name
                        }}
                      </b-badge>
                    </router-link>
                  </template>
                
                  <template #cell(email)="data">
                    <b-badge
                      variant="light-dark"
                      v-if="
                        data.item.quran_schedule_date.length > 0 &&
                          data.item.quran_schedule_date[0].students.length > 0
                      "
                    >
                      {{ data.item.quran_schedule_date[0].students[0].email }}
                    </b-badge>
                  </template>
                  <template #cell(SaveType)="data">
                    <b-badge
                      variant="primary"
                    >
                      {{ data.item.SaveType == "asc" ? "تنازلي" : "تصاعدي" }}


                    </b-badge>
                  </template>
                  <template #cell(archive)="data">
                    <b-button
                      v-if="canArchiveStudent"
                      variant="outline-danger"
                      size="sm"
                      :disabled="!getStudentId(data.item)"
                      @click="archiveStudent(data.item)"
                    >
                      أرشفة الطالب
                    </b-button>
                  </template>
                  <!-- Removed birthdate -->

                  <template #cell(gender)="data">
                    <b-badge
                      variant="light-dark"
                      v-if="
                        data.item.quran_schedule_date.length > 0 &&
                          data.item.quran_schedule_date[0].students.length > 0
                      "
                    >
                      {{ data.item.quran_schedule_date[0].students[0].gender }}
                    </b-badge>
                  </template>
                  <template #cell(teachers)="data">
                    <b-badge
                      variant="light-primary"
                      v-if="
                        data.item.quran_schedule_date.length > 0 &&
                          data.item.quran_schedule_date[0].teachers.length > 0
                      "
                    >
                      {{
                        data.item.quran_schedule_date[0].teachers[0].full_name
                      }}
                    </b-badge>
                  </template>
                  <template #cell(rate)="data">
                    <b-progress
                      :value="AdjustRatePercentage(data.item)"
                      :max="AdjustMaxRatePercentage(data.item)"
                      variant="success"
                      striped
                    />
                  </template>
                  <template #cell(draft)="data">
                    <b-badge
                      variant="light-success"
                      v-if="data.item.draft == 1"
                    >
                      تم تفعيل مقرأة
                    </b-badge>
                    <template v-else>
                      <b-button
                        variant="success"
                        v-if="$role == 'super_admin' || $role == 'QuranAdmin'"
                        @click="setDraft(data.item)"
                      >
                        تفعيل
                      </b-button>
                      <b-badge variant="light-danger" v-else>
                        انتظار التفعيل
                      </b-badge>
                    </template>
                  </template>
                  <template #cell(report)="data">
                    <b-button>تقرير </b-button>
                  </template>
                  <template #cell(meetings)="data">
                    
                      <router-link class="btn btn-primary"
                        v-if="
                          data.item.quran_schedule_date.length > 0 &&
                            data.item.quran_schedule_date[0].teachers.length > 0
                        "
                        :to="{
                          name: 'QuranScheduleDateSystemic',
                          params: { id: data.item.id },
                        }"
                      >
                        {{ $t("quran_programs.live_meetings") }}
                      </router-link>
                     
                  </template>
                  <template #cell(assign_teacher)="data">
                    
                    <button class="btn btn-primary"
                      v-if="$role == 'super_admin' || $role == 'QuranAdmin'"
                      v-b-modal.modal-info
                        @click="
                          openAssign(
                            data.item,
                            'teacher',
                            'عرض اعضاء هيئة التدريس '
                          )
                        "
                    >
                      تعيين معلم
                  </button>
                   
                </template>
                  <!--
                  <template #cell(edit)="data">
                    <b-dropdown
                      :text="$t('site.action')"
                      variant="flat-primary"
                      v-if="data.item.draft == 1"
                    >
                      <b-dropdown-item
                        v-if="
                          data.item.quran_schedule_date.length > 0 &&
                            data.item.quran_schedule_date[0].teachers.length > 0
                        "
                        :to="{
                          name: 'QuranScheduleDateSystemic',
                          params: { id: data.item.id },
                        }"
                      >
                        {{ $t("quran_programs.live_meetings") }}
                      </b-dropdown-item>
                      <b-dropdown-item
                        variant="outline-success"
                        v-b-modal.modal-info
                        v-if="$role == 'super_admin' || $role == 'QuranAdmin'"
                        @click="
                          openAssign(
                            data.item,
                            'teacher',
                            'عرض اعضاء هيئة التدريس '
                          )
                        "
                      >
                        اعضاء هيئة التدريس
                      </b-dropdown-item>
                    </b-dropdown>
                  </template> -->
                </b-table>
                <b-spinner
                  v-if="load"
                  type="grow"
                  label="Loading..."
                  class="loading"
                />
              </b-card>
            </div>
            <!-- end of col -->
          </div>

          <hr />
          <b-pagination
            size="sm"
            class="dataTables_paginate paging_simple_numbers pagination-warning"
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
          >
            <template v-slot:next-text>
              <i class="fas fa-angle-left" />
            </template>
            <template v-slot:prev-text>
              <i class="fas fa-angle-right" />
            </template>
            <template v-slot:first-text>
              <i class="fas fa-step-forward" />
            </template>
            <template v-slot:last-text>
              <i class="fas fa-step-backward" />
            </template>
          </b-pagination>
          <!-- end of row -->
          <b-modal
            id="modal-info"
            ok-variant="info"
            ok-title="save"
            modal-class="modal-info"
            centered
            @ok="save"
            size="lg"
            :title="title"
          >
            <b-table
              :stacked="$mobile == 1"
              :items="users"
              :fields="userfields"
            >
              <template #cell(checkbox)="data">
                <b-form-checkbox v-model="usersSelelcted" :value="data.item.id">
                </b-form-checkbox>
              </template>
            </b-table>

            <!-- <b-spinner v-else type="grow" label="Loading..."  class="loading" /> -->
          </b-modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import controller from "@/Controllers/QuranProgramsController";
import QuranScheduleDate from "@/Controllers/QuranScheduleDateController";
import UsersController from "@/Controllers/UsersController";
import flatPickr from "vue-flatpickr-component";
import Auth from "@/Apis/Auth";
import Swal from "sweetalert2";

export default {
  name: "QuranProgramsDataTable",
  props: ["items", "editItem"],
  components: {
    flatPickr,
  },
  computed: {
    canArchiveStudent() {
      return (
        (Auth.PERMISSIONS && Auth.PERMISSIONS.includes("archive_student")) ||
        this.$role == "super_admin"
      );
    },
    teachers(){
      if(this.teachers_list.length > 0) return this.teachers_list;
      let teachers_arr = [];
      for(let i = 0; i < this.data.length; i++){
        for(let x = 0; x < this.data[i].quran_schedule_date.length;x++){
          for(let y = 0; y < this.data[i].quran_schedule_date[x].teachers.length;y++){
            teachers_arr.push({
              id: this.data[i].quran_schedule_date[x].teachers[y].id,
              full_name: this.data[i].quran_schedule_date[x].teachers[y].full_name
            })
          }
        }
      }
      teachers_arr.unshift({
        id: 0,
        full_name: "الكل"
      })
      let list = teachers_arr.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i);
      return list;
  
    }
  },
  data() {
    return {
      teachers_list : [],
      dateNtim: null,
      schedules: [],
      itemView: "DataTable",
      controller: new controller(),
      title: "",
      newDate: {},
      draft: 1,
      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: [
          {
            key: "id",
            label: this.$i18n.t("site.code"),
            sortable: true,
          },
          {
            key: "type.name",
            label: "الرواية",
            sortable: true,
          },
          {
            key: "quran_schedule_date",
            label: this.$i18n.t("quran_programs.students"),
            sortable: false,
          },

          {
            key: "email",
            label: this.$i18n.t("users.email"),
            sortable: false,
          },
          {
            key: "gender",
            label: this.$i18n.t("students.gander"),
            sortable: true,
          },

          {
            key: "teachers",
            label: this.$i18n.t("quran_programs.teachers"),
            sortable: true,
          },

          {
            key: "period",
            label: "  رقم الجزء ",
            sortable: false,
          },
          {
            key: "SaveType",
            label: "  نوع الحفظ",
            sortable: false,
          },
          {
            key: "rate",
            label: this.$i18n.t("quran_programs.rate"),
            sortable: false,
          },

          {
            key: "draft",
            label: this.$i18n.t("quran_programs.draft"),
            sortable: false,
          },
          //
          // { key: "edit", label: this.$i18n.t("site.action"), sortable: false },
          {
            key : "meetings",
            label : "اللقاءات",
            sortable : false
          },
          {
            key : "assign_teacher",
            label : "تعيين معلم",
            sortable : false
          },
          {
            key: "archive",
            label: "أرشفة",
            sortable: false,
          }
        ],
      },
      data: {
        teachersFilter: false,
      },
      selectAll: false,
      currentPage: 1,
      select: [],
      page: 1,
      perPage: 5,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
      recordIds: [],
      users: {},
      userfields: [
        { key: "checkbox", label: "", sortable: false },
        {
          key: "code",
          label: this.$i18n.t("students.academic_number"),
          sortable: true,
        },

        {
          key: "first_name",
          label: this.$i18n.t("students.first_name"),
          sortable: true,
        },
        {
          key: "last_name",
          label: this.$i18n.t("students.last_name"),
          sortable: true,
        },

        {
          key: "email",
          label: this.$i18n.t("users.email"),
          sortable: true,
        },
      ],
      programSelelcted: {},
    };
  },
  async created() {
    // this.itemView = "grid-view";
    const itemViewOptions = [
      { icon: "GridIcon", value: "grid-view" },
      { icon: "ListIcon", value: "list-view" },
    ];
    // systemic
    this.users = await new UsersController().GetAll({
      type: "teacher",
      filter: "quran_program_supervise|1",
    });
    this.dataProvider(this.params);
  },

  methods: {
    filterGender(gender){
      let dir = "desc";
      if(gender == "male"){
        dir = "asc";
        }
      this.params.sort = "gender|"+dir;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    filterTeachers(teacher){
      if(teacher == 0){
        this.params.teacher_id = null;
        this.dataProvider(this.params);
        this.$refs.table.refresh();
        return;
      }
      //get programs with teacher id from quran_schedule_date
      this.params.teacher_id = teacher;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    AdjustRatePercentage(item) {
        let done = 0;
        for(let i in item.quran_schedule_date){
          if(item.quran_schedule_date[i].complete == 1){
            done++;
          }
        }
        return done;
    },
    AdjustMaxRatePercentage(item) {
      let SaveType = item.SaveType;
      let period = item.period;
      if(SaveType == "asc"){
        return (30 - period + 1) * 8;
      }else if(SaveType == "desc"){
        return period * 8;
      }
    },
    async setDraft(item) {
      await this.controller.Updata({ id: item.id, draft: 1 });
      this.$refs.table.refresh();
    },
    getStudentId(item) {
      if (
        item &&
        item.quran_schedule_date &&
        item.quran_schedule_date.length > 0 &&
        item.quran_schedule_date[0].students &&
        item.quran_schedule_date[0].students.length > 0
      ) {
        return item.quran_schedule_date[0].students[0].id;
      }
      return null;
    },
    async archiveStudent(item) {
      const studentId = this.getStudentId(item);
      if (!studentId) return;
      const studentName = item.quran_schedule_date[0].students[0].full_name;
      const result = await Swal.fire({
        position: "top-start",
        title: "أرشفة الطالب",
        text: `سيتم نقل كل مقارئ الطالب ${studentName} إلى المعلم المؤرشف. هل أنت متأكد؟`,
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "إلغاء",
        confirmButtonColor: "#ce7b2c",
        cancelButtonColor: "#28c76f",
        confirmButtonText: "نعم ، قم بالأرشفة",
      });
      if (!result.isConfirmed) return;
      await this.controller.ArchiveStudent(studentId);
      this.$refs.table.refresh();
    },
    refresh() {
      this.$refs.table.refresh();
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    async dataProvider(ctx) {
      console.log(ctx);
      this.load = true;
      this.params = ctx;
      const data = await this.controller.GetAll(this.apiParamsConverter());
      this.currentPage = data.current_page;
      this.perPage = data.per_page;
      this.totalRows = data.total;
      this.from = data.from;
      this.to = data.to;
      this.total = data.total;
      this.data = data.data;
      this.load = false;
      return data.data;
    },
    apiParamsConverter() {
      let apiParams = { per_page: this.perPage };
      if (this.params.currentPage >= 1) {
        apiParams.page = this.params.currentPage;
      }
      if (this.params.sortBy && this.params.sortBy.length > 0) {
        apiParams.sort = `${this.params.sortBy}|${
          this.params.sortDesc ? "desc" : "asc"
        }`;
      }
      if(this.params.sort){
        apiParams.sort = this.params.sort;
      }
      if (this.params.filter && this.params.filter.length > 0) {
        apiParams.filter = this.params.filter;
      }
      if (this.search !== "") {
        apiParams.search = this.search;
      }
      if(this.params.teacher_id){
        apiParams.teacher_id = this.params.teacher_id;
      }
      apiParams.filter = "systemic|1&&draft|" + this.draft;
      apiParams.with = [
        "quranScheduleDate.students",
        "type",
        "quranScheduleDate.teachers",
       // "user.country.phone_code"
      ];
      //TeachersFilter 
      if(this.teachersFilter){
        apiParams.joins = "quran_schedule_date_user.user_id|"+this.teachersFilter;
      }
   
      // apiParams.withCount = ["quranScheduleDate"];

      return apiParams;
    },
    changePageSize(perPage) {
      this.page = 1;
      this.perPage = perPage;
      this.$refs.table.refresh();
    },
    searchChange() {
      if (this.search.length == 0) {
        this.$refs.table.refresh();
      }
      if (this.search.length < 2) return;
      this.page = 1;
      this.$refs.table.refresh();
    },
    async save() {
      this.studentsLoad = true;
      await new QuranScheduleDate().assignTeacherDate(
        this.programSelelcted.quran_schedule_date[0].id,
        {
          teacher_ids: this.usersSelelcted,
        }
      );
      this.studentsLoad = false;
      this.usersSelelcted = [];
      this.programSelelcted = {};
    },
    async openAssign(item, type, title) {
      this.title = title;
      this.programSelelcted = item;

      this.studentsLoad = true;
      this.usersSelelcted = item.quran_schedule_date[0].teachers.map(
        (x) => x.id
      );

      this.studentsLoad = false;
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/base/pages/app-ecommerce.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss" scoped>
.item-view-radio-group ::v-deep {
  .btn {
    display: flex;
    align-items: center;
  }
}
</style>